var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[
        'Section',
        _vm.open && 'Section--open' ]},[_c('a',{class:[
            'Section__container',
            _vm.open && 'Section__container--open',
            _vm.isActive && 'Section__container--active'
        ],attrs:{"href":_vm.section.path},on:{"click":function($event){$event.preventDefault();return _vm.nav($event)}}},[_c('StreamlineIcon',{class:[ 'Section__menu', _vm.open && 'Section__menu--open' ],attrs:{"icon":_vm.icon,"stroke":_vm.white,"size":20}}),(_vm.open)?[_vm._v(" "+_vm._s(_vm.section.label)+" ")]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }